import { FavoritesResource } from 'affiny-core/modules/api/core/resources/favorites.resource';
import { IApiFavoritesResult } from 'affiny-core/modules/api/models/interactions/favorites/favorite.types';
import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { interactionsNormalizer } from '../interactions.normalizer';

export function* postFavorite(
  otherAccountId: string,
  ratingStatus: string,
  ratingFeature: string,
  eventOrigin: string
) {
  const myAccountId: string = yield select(selectAccountId);

  return yield call(
    FavoritesResource.postFavorite,
    myAccountId,
    otherAccountId,
    ratingStatus,
    ratingFeature,
    eventOrigin
  );
}

const PAGE_SIZE = 20;

export function* getReceivedFavorites(
  pageNumber: number,
  pageSize: number = PAGE_SIZE
) {
  const myAccountId: string = yield select(selectAccountId);

  // eslint-disable-next-line no-useless-catch
  try {
    const result: IApiFavoritesResult = yield call(
      FavoritesResource.getReceivedFavorites,
      myAccountId,
      pageNumber,
      pageSize
    );

    return interactionsNormalizer(result);
  } catch (e) {
    // TODO handle error case in paginated saga instead of doing it in each call
    throw e;
  }
}

export function* getSentFavorites(pageNumber: number, pageSize = PAGE_SIZE) {
  const myAccountId: string = yield select(selectAccountId);
  const result: IApiFavoritesResult = yield call(
    FavoritesResource.getSentFavorites,
    myAccountId,
    pageNumber,
    pageSize
  );

  return interactionsNormalizer(result);
}
